import { DeadlineIcon } from '@sketchnote/icons';
import { Avatar } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { API, endpoints } from 'src/api';
import { useLayout } from 'src/shared/hooks/use-layout';
import { getFormattedValue } from 'src/utils/getFormattedValue';

import { renderMessageForType } from './components/notification-template';
import { NotificationProps } from './types';

export const PopUpNotification = ({
  notificationPayload,
  handleResetNotificationPayload,
}: {
  notificationPayload: NotificationProps;
  handleResetNotificationPayload: () => void;
}) => {
  const [id, setId] = useState<string | null>(null);
  const {
    setLiveActionType,
    liveActionType,
    onCloseNotifications,
    notificationCount,
    incrementNotificationCount,
    decrementNotificationCount,
  } = useLayout();

  const router = useRouter();
  const { type, sender, detail } = notificationPayload;
  useEffect(() => {
    if (notificationPayload.id) {
      const ping = new Audio(
        'https://res.cloudinary.com/samvibes/video/upload/v1709208658/sounds/notification.wav'
      );

      incrementNotificationCount();
      ping.play();

      setId(notificationPayload.id);

      setTimeout(() => {
        setLiveActionType(null);
      }, 8000);
    }
    return () => {
      setId(null);
      handleResetNotificationPayload();
    };
  }, [notificationPayload.id]);

  const handleClickNotification = async () => {
    const response = await API.put(endpoints.notifications.markAsRead, {
      id: notificationPayload.id,
    });
    if (notificationCount > 0) {
      decrementNotificationCount();
    }
    const urlToGo = notificationPayload.url;
    setLiveActionType(null);
    onCloseNotifications();
    router.push(urlToGo);
  };
  if (!Object.keys(renderMessageForType).includes(type)) {
    return <></>;
  }
  return id && id === notificationPayload.id ? (
    <div
      style={{
        borderRadius: '12px',
        animation: `${
          liveActionType === 'null'
            ? 'notificationUnmountAnimationTranslate'
            : 'notificationAnimationTranslate'
        } 1s ease forwards`,
      }}
      className="bg-blue-175 w-440 absolute right-9 top-75 z-1000 flex border-2 border-white shadow-mdl"
    >
      <div
        className="flex flex-grow items-start p-8"
        role="button"
        onClick={handleClickNotification}
      >
        {type === 'reminder' ? (
          <div className="border rounded-md p-1.5">
            <DeadlineIcon />
          </div>
        ) : type !== 'final_status' ? (
          <span className="border rounded-full p-4">
            <Avatar name={sender?.firstname} src={sender?.avatar} size="md" type="notification" />
          </span>
        ) : (
          <></>
        )}
        <div className="ml-12 text-sm my-auto max-w-300">
          {type !== 'reminder' && (
            <span className="block font-medium text-sm" style={{ color: '#0A0D14' }}>
              {sender?.firstname || 'User'}&nbsp;
            </span>
          )}
          <span style={{ color: '#525866' }} className="title">
            {renderMessageForType[type] ? (
              <span className="first-letter:capitalize">
                {renderMessageForType[type].charAt(0).toUpperCase() +
                  renderMessageForType[type].slice(1)}{' '}
              </span>
            ) : (
              <span />
            )}

            {detail?.action && type === 'approval_completed' && (
              <span className="capitalize">{detail?.action}&nbsp;</span>
            )}
            {detail && Object.keys(detail).length > 0 && (
              <span className="">
                {detail?.location === 'board_task'
                  ? `Task: ${getFormattedValue(detail?.task) || 'Untitled'}`
                  : detail?.location === 'file'
                  ? `file: ${detail?.file || 'Untitled'}`
                  : detail?.location === 'workspace'
                  ? `workspace: ${detail?.workspace || 'Untitled'}`
                  : 'Untitled'}
              </span>
            )}
            {detail?.action && type === 'final_status' && (
              <span className="capitalize">&nbsp;is&nbsp;{detail?.action}&nbsp;</span>
            )}
          </span>
        </div>
      </div>
      <button
        style={{ borderColor: '#C2D6FF' }}
        className="w-64 border-l  items-center text-xs text-gray-999"
        onClick={(e) => {
          e.preventDefault();
          setLiveActionType(null);
          setId(null);
        }}
      >
        Close
      </button>
    </div>
  ) : (
    <></>
  );
};
